
import { OioButton, OioForm, OioFormItem, OioModal } from '@kunlun/vue-ui-antd';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Action',
  components: {
    OioButton,
    OioForm,
    OioFormItem,
    OioModal
  },
  inheritAttrs: false,
  props: [
    'action',
    'validateAndClick',
    'label',
    'visible',
    'invisible',
    'change',
    'doImport',
    'downloadTemplate',
    'options',
    'handleSelectChange',
    'workbookList',
    'selectValue',
    'validation1',
    'validation2',
    'loading',
    'remove'
  ]
});
